import { createConstants } from 'redux-model-tools';

export default createConstants('PORTAL_EMAIL_CONFIRMATION', [
  'RESEND_CONFIRMATION_EMAIL',
  'RESEND_CONFIRMATION_EMAIL_RESULT',
]);
